// 扩展 Storage 原型以添加自定义方法
if (!Storage.prototype.setObject) {
  Storage.prototype.setObject = function(key, value) {
    this.setItem(key, JSON.stringify(value))
  }
}
if (!Storage.prototype.getObject) {
  Storage.prototype.getObject = function(key) {
    const value = this.getItem(key)
    try {
      const obj = value ? JSON.parse(value) : null
      return obj
    } catch (e) {
      console.error('Json 解析 Storage.getObject 返回值错误, 值:', value)
      return {}
    }
  }
}

export default {
  // RFC4122 version 4 compliant UUID generator
  guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0
      const v = c === 'x' ? r : (r & 0x3 | 0x8)
      return v.toString(16)
    })
  },

  async getConfigSignature(url) {
    // 根据 url 生成企业签名
    // 生成方法参考 https://developer.work.weixin.qq.com/document/14924
    return { timestamp, nonceStr, signature }
  },

  async getAgentConfigSignature(url) {
    // 根据 url 生成应用签名，生成方法同上，但需要使用应用的 jsapi_ticket
    return { timestamp, nonceStr, signature }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/utility.js